<template>
    <div>
        <!-- If not redirected for some reason button -->
        <a @click="redirect">Redirect</a>
    </div>
</template>

<script>
export default {
    created(){
        this.redirect();
    },

    methods : {
        redirect(){
            const lang = 'lt';
            this.$router.push({ name: 'home', params: { lang } }).catch(() => {});
        }
    }
}
</script>